import { Link } from 'react-router-dom'
import { CuraButtonOutline, CuraLabel } from '@rededor/cura-react'
import styled, { css, keyframes } from 'styled-components'
import { buttonReset } from '@/shared/styles/mixins'
export { Bold } from '@/shared/styles/styled-elements'

const PriceButtonIconLoadingAnimation = keyframes`
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.8);
  }
`

export const RootContainer = styled.article`
  ${({ theme }) => css`
    background-color: ${theme.colors.getColor('neutral-purewhite')};
    padding: 16px 16px 20px 16px;

    &:not(:last-of-type) {
      border-bottom: 1px solid ${theme.colors.getColor('neutral-light')};
    }

    @media (min-width: ${theme.breakpoints.get('medium', 'max')}px) {
      padding: 16px;
    }
  `}
`

export const RootContent = styled.div``

export const SectorNameContainer = styled(Link)<{ $disabled: boolean }>`
  ${({ $disabled, theme }) => css`
    align-items: center;
    display: flex;
    font-weight: ${theme.fonts.getWeights().black};
    gap: 12px;
    pointer-events: ${$disabled ? 'none' : 'initial'};
    text-decoration: none;
  `}
`

export const InfoContainer = styled.div`
  ${({ theme }) => css`
    padding: 12px 0;

    @media (min-width: ${theme.breakpoints.get('medium', 'max')}px) {
      padding: 8px 0 12px 0;
    }
  `}
`

export const ActionsContainer = styled.div`
  padding-bottom: 12px;
`

export const ButtonsWrapper = styled.div<{ $hasFavoriteUnitButton?: boolean }>`
  ${({ $hasFavoriteUnitButton = false }) => css`
    align-items: center;
    display: flex;
    flex-direction: ${$hasFavoriteUnitButton ? 'row' : 'row-reverse'};
    justify-content: space-between;
  `}
`

export const ButtonFavoriteContainer = styled.button<{ $isChecked: boolean }>`
  ${({ theme, $isChecked }) => css`
    ${buttonReset}
    background-color: ${$isChecked
      ? theme.colors.getColor('primary-base')
      : theme.colors.getColor('neutral-white')};
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    gap: 5px;
    padding: 4px;
  `}
`

export const ButtonPriceContainer = styled.button`
  ${buttonReset}

  align-items: center;
  cursor: pointer;
  display: flex;
  height: 32px;
  gap: 8px;
`
export const ButtonPriceIcon = styled.div<{ $loading: boolean }>`
  ${({ $loading }) => css`
    animation: ${$loading
      ? css`
          ${PriceButtonIconLoadingAnimation} 1000ms
      cubic-bezier(0.175, 0.885, 0.320, 1.275) infinite
        `
      : 'none'};

    > cura-icon {
      display: block;
    }
  `}
`

export const ButtonPriceLabel = styled.span`
  align-items: center;
  display: flex;
  gap: 4px;
`

export const AlertPriceWrapper = styled.div`
  margin-top: 12px;
`

export const SlotsContainer = styled.article`
  ${({ theme }) => css`
    border-top: 1px dashed ${theme.colors.getColor('neutral-light')};
    padding: 20px 0 0 0;

    @media screen and (min-width: ${theme.breakpoints.get('medium', 'max')}px) {
      padding: 24px 0 0 0;
    }
  `}
`

export const SlotsContent = styled.div`
  ${({ theme }) => css`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px 16px;

    @media screen and (min-width: ${theme.breakpoints.get('medium', 'max')}px) {
      grid-template-columns: repeat(auto-fill, minmax(78px, 78px));
      gap: 12px;
    }
  `}
`

export const ButtonSlot = styled(CuraButtonOutline)`
  ${({ theme }) => css`
    & > span {
      color: ${theme.colors.getColor('accent')};
      margin-left: 4px;
    }
  `}
`

export const FitScheduleContainer = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    gap: 14px;
    margin-top: 12px;

    @media screen and (min-width: ${theme.breakpoints.get('medium', 'max')}px) {
      margin-top: 24px;
    }
  `}
`

export const FitScheduleLabel = styled(CuraLabel)`
  ${({ theme }) => css`
    & > span {
      color: ${theme.colors.getColor('accent')};
    }
  `}
`
export const AlertWrapper = styled.div`
  display: flex;
  gap: 20px;
  flex-direction: column;
  padding: 12px 0;
`
